import React, { Fragment, useRef } from 'react';
import { Button, Form, InputGroup, Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { searchProductForSelect, setImagePopup } from "../store/api/GetAllProduct";
import { CardImage, CheckSquare, Dash, DashLg, Plus, X } from "react-bootstrap-icons";
import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faObjectGroup, faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalProducts = (props) => {
    const { setPopupData, popData, productGrouppingType } = props;
    const { show, setProductData, selectMultiple, groupID, groupName } = popData;
    const selectedProductList = useSelector(state => state.customerDataReducer.selectedProductList);
    const selectedItems = useRef([]);
    const searchData = useRef({});
    const dispatch = useDispatch();
    // let imageclicked = false;
    const handleModal = () => {
        setProductData(null);
        setPopupData({ show: false });
    }
    const search = (e) => {
        if (e.key && e.key !== "Enter") {
            return;
        }
        searchData.current.Take = 50;
        searchData.current.GroupID = groupID;
        searchData.current.InService = true;
        selectedItems.current = [];
        dispatch(searchProductForSelect(searchData.current));
    }
    const select = (dt) => {
        // if (imageclicked) {
        //     imageclicked = false;
        //     return;
        // }
        const item = dt.item;
        var data = {};
        data.ProductID = item.ID;
        data.ProductName = item.Name;
        data.ProductModel = item.Model;
        data.HolderName = item.HolderName;
        data.UnitPrice = item.LastPurchasePrice ?? 0;
        data.SuggestedCount = item.SuggestedCount ?? 1;
        if (!selectMultiple && dt.currentTarget.tagName.toLowerCase() === "tr") {
            if (setProductData) {
                setProductData(data);
            }
            setPopupData({ show: false });
        }
        else if (selectMultiple && dt.currentTarget.tagName.toLowerCase() === "input") {
            const checked = dt.currentTarget.checked;
            if (checked) {
                selectedItems.current.push(data);
            }
            else if (selectedItems.length > 0) {
                selectedItems.current = selectedItems.current.filter(s => Number(s.ProductID) !== Number(data.ProductID));
            }
        }
    }
    function changeProductCount(id, e) {
        e.preventDefault();
        const found = selectedItems.current.find(s => Number(s.ProductID) == Number(id));
        if (found) {
            found.SuggestedCount = Number(e.target.value);
        }
    }
    return (
        <Modal size='lg' show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                انتخاب کالا از لیست
                <span onClick={handleModal} style={{ cursor: "pointer" }}>
                    <FontAwesomeIcon icon={faTimes} size='lg' />
                </span>
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                {groupName && groupID && <span style={{padding:"3px", backgroundColor:"#5b53d9f5", color: "white"}}><FontAwesomeIcon icon={faObjectGroup}/>&nbsp; کالاهای گروه: {groupName}</span>}
                <div className="row">
                    {(productGrouppingType === 1) &&
                        <div className="form-group col-md-4 mt-1">
                            <input type="text" placeholder="کد کالا" className="form-control"
                                onChange={e => searchData.current.Code = e.target.value} onKeyDown={search} />
                        </div>
                    } {productGrouppingType !== 1 &&
                        <div className="form-group col-md-4  mt-1">
                            <input type="text" placeholder="مارک کالا" className="form-control"
                                onChange={e => searchData.current.HolderName = e.target.value}
                                onKeyDown={search} />
                        </div>
                    }
                    <div className="form-group col-md-4  mt-1">
                        <input type="text" placeholder={(productGrouppingType === 1) ? ('نام کالا') : ('نوع کالا')} className="form-control"
                            onChange={e => searchData.current.Name = e.target.value} onKeyDown={search} />
                    </div>
                    <div className="form-group col-md-4  mt-1">
                        <input type="text" placeholder="مدل کالا" className="form-control"
                            onChange={e => searchData.current.Model = e.target.value} onKeyDown={search} />
                    </div>
                </div>
                <button type="button" className="btn btn-primary w-100 mt-2" onClick={search}>جستجو</button>
                <br />
                <br />
                <div className='scThin' style={{maxHeight:"250px", overflow:"auto"}}>
                <Table className='mb-0'>
                    <thead>
                        <tr style={{ padding: "0" }}>
                            {productGrouppingType !== 1 && <th style={{position:"sticky", top:0, backgroundColor:"#bbb8b8"}}>مارک کالا</th>}
                            <th style={{position:"sticky", top:0, backgroundColor:"#bbb8b8"}}>{productGrouppingType === 1 ? "نام کالا" : "نوع کالا"}</th>
                            <th style={{position:"sticky", top:0, backgroundColor:"#bbb8b8"}}>مدل کالا</th>
                            {selectMultiple &&
                                <Fragment>
                                    <th>تعداد کالای انتخابی</th>
                                </Fragment>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            selectedProductList && selectedProductList === "PENDING" &&
                            <tr><td colSpan={2 + (productGrouppingType !== 1 ? 1 : 0) + (selectMultiple ? 2 : 0)} style={{ textAlign: "center", width: "100%" }}><Loader width={25} height={25} type="BallTriangle" color="#bb1370" /></td></tr>
                        }
                        {selectedProductList && selectedProductList.Error &&
                            <tr><td colSpan={2 + (productGrouppingType !== 1 ? 1 : 0) + (selectMultiple ? 2 : 0)} style={{ textAlign: "center", color: "red" }}>{selectedProductList.Error}</td></tr>
                        }
                        {selectedProductList && Array.isArray(selectedProductList) &&
                            selectedProductList.map((item, i) => {
                                return (
                                    <tr className='resultTableRow' key={i} onClick={(e) => select({ ...e, item: item })}>

                                        {productGrouppingType !== 1 && <td>{item?.HolderName}</td>}
                                        <td>{item?.Name}</td>
                                        <td>{item?.Model}</td>
                                        {selectMultiple &&
                                            <td style={{ width: "120px" }}>
                                                <InputGroup>
                                                    <input type='checkbox' className='form-check-input' onClick={(e) => select({ ...e, item: item })} style={{ marginTop: "6px" }} />
                                                    <Form.Control type='number' style={{ paddingLeft: "2px", height: "27px", fontSize: "12px", marginRight: "6px" }}
                                                        defaultValue={1} min={1}
                                                        onChange={(e) => { changeProductCount(item.ID, e); }}
                                                    />
                                                </InputGroup>
                                            </td>}
                                    </tr>)
                            })
                        }
                    </tbody>
                </Table>
                </div>
                {selectMultiple && <Button className='group-Btn-large' variant='info'><CheckSquare />&nbsp; تایید کالاهای انتخاب شده</Button>}
            </Modal.Body>
        </Modal >
    )
}
export default ModalProducts;